export default __webpack_public_path__ + "static/media/AkaPosse.6b9c1534.ttf";